import api from "@/api/viktor"
import type { NextAssessment } from "@/types/next-assessment"

export async function getNextAssessment(
  uuid?: string,
  retake?: boolean
): Promise<NextAssessment> {
  let path = `/me/next-assessment`
  if (uuid) {
    path = `${path}?workflow_user_uuid=${uuid}`
  }
  if (retake) {
    path = `${path}&retake=true`
  }

  const response = await api({
    method: "GET",
    url: path,
  })

  console.log(JSON.stringify(response))

  return response
}
